import { Injectable } from '@angular/core';
import { catchError, finalize } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FidelityPageService } from '../../../core/services/fidelity-page.service';
import { ApiResult } from '../../types/api-result.types';
import { RegistrationDto, RegistrationFromCardDto } from './registration-form.types';

@Injectable({
    providedIn: 'root',
})
export class RegistrationFormService extends FidelityPageService {
    registerNew(dto: RegistrationDto) {
        this.disableCrudActions.set(true);
        return this.http
            .post<ApiResult<string>>(`${environment.apiUrl}/auth/registration/new`, dto)
            .pipe(
                catchError((err) => this.handleError(err)),
                finalize(() => this.disableCrudActions.set(false))
            );
    }

    registerFromCard(dto: RegistrationFromCardDto) {
        this.disableCrudActions.set(true);
        return this.http
            .post<ApiResult<string>>(`${environment.apiUrl}/auth/registration/from-card`, dto)
            .pipe(
                catchError((err) => this.handleError(err)),
                finalize(() => this.disableCrudActions.set(false))
            );
    }
}
